import { Dialog, RaisedButton } from "material-ui";
import Clear from "material-ui/svg-icons/content/clear";
import React from "react";
import { FormattedMessage } from "react-intl";
import Clipboard from "react-clipboard.js";

export const closeIconStyle = {
  position: "absolute",
  top: "8px",
  right: "5px",
  color: "#4f4f4f",
  height: "28px",
  width: "28px",
  cursor: "pointer"
};

export function ActionButton(props) {
  return (
    <RaisedButton
      onTouchTap={props.onTouchTap}
      className="email-invite-btn action-btn"
      label={<FormattedMessage id={`roomList.${props.label}`} />}
      backgroundColor="#60d1bd"
      labelStyle={{ color: "#fff",  textTransform: props.labelTransform ? "none" : "uppercase", }}
      style={{
        height: 42,
        margin: "10px 0",
        marginLeft: "12px",
        minWidth: "180px",
      }}
    />
  );
}

export class CopyURLDialog extends React.Component {
  render() {
    return (
      <Dialog
        modal={true}
        open={this.props.open}
        onRequestClose={this.handleClose}
        autoScrollBodyContent={false}
        contentStyle={{
          width: "85%",
        }}
      >
        <Clear onClick={this.props.handleClose} style={closeIconStyle} />
        <div style={{ marginTop: "26px" }}>
          <Clipboard
            data-clipboard-text={this.props.guestURL}
            onSuccess={() =>
              this.props.onUrlCopied(
                this.props.isWebinar ? "webinarUrlCopiedMessage" : "urlCopy"
              )
            }
            style={{
              border: "none",
              background: "transparent",
              padding: "0px",
              width: "100%",
            }}
          >
            <ActionButton
              onTouchTap={() => {}}
              label={this.props.isWebinar ? "participantUrl" : "invitationUrl"}
            />
          </Clipboard>
          <Clipboard
            data-clipboard-text={this.props.hostURL}
            onSuccess={() =>
              this.props.onUrlCopied(
                this.props.isWebinar
                  ? "webinarPublisherUrlCopiedMessage"
                  : "hostUrlCopy"
              )
            }
            style={{
              border: "none",
              background: "transparent",
              padding: "0px",
              width: "100%",
            }}
          >
            <ActionButton
              onTouchTap={() => {}}
              label={this.props.isWebinar ? "lectureUrl" : "hostUrl"}
            />
          </Clipboard>
        </div>
      </Dialog>
    );
  }
}

export class OtherRoomActions extends React.Component {
  render() {
    return (
      <Dialog
        modal={true}
        open={this.props.open}
        onRequestClose={this.handleClose}
        contentStyle={{
          width: "85%",
        }}
      >
        <Clear onClick={this.props.handleClose} style={closeIconStyle} />
        <div style={{ marginTop: "26px" }}>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <ActionButton
              onTouchTap={() => {
                this.props.handleInvitationEmail(
                  this.props.selectedRoom,
                  this.props.isWebinar
                );
              }}
              label="invitationEmail"
            />
          </div>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <ActionButton
              onTouchTap={() => this.props.editRoom(this.props.selectedRoom)}
              label="edit"
            />
          </div>
        </div>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// src/components/Seminars/RoomActionDialog.js